import { useMemo } from 'react'

import { useMediaQuery } from 'react-responsive'

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

const queries = {
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  '2xl': '(min-width: 1536px)'
}

export const useBreakpoints = () => {
  // do menor pro maior, acumulando se "bate" aquele ponto de corte
  const is2xl = useMediaQuery({ query: queries['2xl'] })
  const isXl = useMediaQuery({ query: queries['xl'] })
  const isLg = useMediaQuery({ query: queries['lg'] })
  const isMd = useMediaQuery({ query: queries['md'] })
  const isSm = useMediaQuery({ query: queries['sm'] })

  // Determina qual breakpoint está ativo
  const breakpoint: Breakpoint = useMemo(() => {
    if (is2xl) return '2xl'
    if (isXl) return 'xl'
    if (isLg) return 'lg'
    if (isMd) return 'md'
    if (isSm) return 'sm'
    return 'xs'
  }, [isSm, isMd, isLg, isXl, is2xl])

  // Mantém compatibilidade com a API original
  const isMobile = breakpoint === 'xs' || breakpoint === 'sm'
  const isTablet = breakpoint === 'md'
  const isDesktop =
    breakpoint === 'lg' || breakpoint === 'xl' || breakpoint === '2xl'

  const isAtLeast = (min: Breakpoint) => {
    const order: Breakpoint[] = ['xs', 'sm', 'md', 'lg', 'xl', '2xl']
    return order.indexOf(breakpoint) >= order.indexOf(min)
  }

  return {
    breakpoint,
    isMobile,
    isTablet,
    isDesktop,
    isAtLeast
  }
}
